import { api } from '@services';

export interface ProductCriticalData {
  model: string;
  id: string;
  manufacturerName: string;
  imageUrl?: string;
}
const getProductModels = async (
  search: string,
): Promise<ProductCriticalData[]> => {
  const { data: productModels } = await api.get<ProductCriticalData[]>(
    `/products/models/${encodeURIComponent(search)}`,
  );

  return productModels;
};

export { getProductModels };
